import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
} from 'react-native';
import { ms, s, vs } from '../../../../utils/responsive';
import { BottomNavBar } from '../../../../components/BottomNavBar';
import { useNavigation, useRoute, RouteProp } from '@react-navigation/native';

type RouteParams = {
  taskId: number;
};

export const PersonalInfoIntroScreen: React.FC = () => {
  const navigation = useNavigation();
  const route = useRoute<RouteProp<Record<string, RouteParams>, string>>();
  const taskId = route.params?.taskId || 1;

  const getTaskTitle = (id: number) => {
    switch (id) {
      case 1: return 'Identifying Information';
      case 2: return 'Employment Information';
      case 3: return 'Spouse Information';
      case 4: return 'Children Information';
      case 5: return 'Pet Information';
      default: return 'Personal Information';
    }
  };

  const handleGetStarted = () => {
    (navigation as any).navigate('PersonalInfoInput', { taskId });
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.mainContent}>
        <View style={styles.header}>
          <TouchableOpacity 
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Image
              source={require('../../../../assets/icons/back.png')}
              style={styles.backIcon}
            />
          </TouchableOpacity>
          <Image
            source={require('../../../../assets/logo.png')}
            style={styles.logo}
            resizeMode="contain"
          />
        </View>

        <ScrollView contentContainerStyle={styles.content}>
          <Text style={styles.title}>{getTaskTitle(taskId)}</Text>
          
          <Text style={styles.description}>
            Preparing for life's uncertainties is an important way to care for your loved ones. 
            By organizing your personal information in advance, you ensure that, in the event of 
            catastrophic event where your immediate family is no longer with us or is also 
            incapacitated, your friends and other family members can easily access critical 
            information. This helps them make informed decisions, manage your affairs, 
            and honor your wishes without added stress. It's a thoughtful step that provides 
            peace of mind and eases the emotional burden on your family during difficult times.
          </Text>

          <TouchableOpacity 
            style={styles.button}
            onPress={handleGetStarted}
          >
            <Text style={styles.buttonText}>Let's Get Started</Text>
            <Text style={styles.buttonArrow}>{'>>'}</Text>
          </TouchableOpacity>
        </ScrollView>
      </View>
      <BottomNavBar />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F3F6F8',
  },
  mainContent: {
    flex: 1,
    paddingTop: ms(50),
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ms(15),
    position: 'relative',
  },
  backButton: {
    position: 'absolute',
    left: ms(50),
    top: ms(15),
    padding: ms(5),
    zIndex: 1,
  },
  backIcon: {
    width: ms(32, 0.3),
    height: ms(32, 0.3),
    tintColor: '#333',
  },
  logo: {
    width: ms(125, 0.3),
    height: ms(125, 0.3),
  },
  content: {
    flexGrow: 1,
    paddingHorizontal: ms(20),
    paddingTop: ms(20),
    paddingBottom: ms(110),
    alignItems: 'center',
  },
  title: {
    fontSize: ms(24, 0.3),
    fontWeight: 'bold',
    color: '#1C2C4F',
    marginBottom: ms(20),
    textAlign: 'center',
  },
  description: {
    fontSize: ms(16, 0.3),
    color: '#1C2C4F',
    textAlign: 'center',
    lineHeight: ms(24, 0.3),
    marginBottom: ms(40),
  },
  button: {
    backgroundColor: '#29BFC0',
    borderRadius: ms(25),
    paddingVertical: ms(15),
    paddingHorizontal: ms(30),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80%',
    marginTop: 'auto',
    marginBottom: ms(30),
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: ms(18, 0.3),
    fontWeight: '600',
    marginRight: ms(10),
  },
  buttonArrow: {
    color: '#FFFFFF',
    fontSize: ms(18, 0.3),
    fontWeight: '600',
  },
}); 